// import { fetchToken } from "../../common/FetchCookie";
// import { ADMIN, BASE_URL, EMPLOYER_DATA, EMPLOYER_PROFILE_VERIFIED } from "../../common/URLs";


// const API_BASE_URL = `${BASE_URL}/${ADMIN}/${EMPLOYER_DATA}`
// const API_VERIFY_URL = `${BASE_URL}/${ADMIN}/${EMPLOYER_PROFILE_VERIFIED}`

// export const fetchEmployerData = async (page = 1) => {
//   const url = `${API_BASE_URL}?page=${page}`;
//   try {
//     const token = await fetchToken()

//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         Accept: "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//     const data = await response.json();
//     return {
//       candidates:
//         data.response.data.map((candidate) => ({
//           ...candidate,
//           is_verified: candidate.is_verified === 1, // Convert to boolean
//         })) || [],
//       pagination: {
//         current_page: data.response.current_page,
//         last_page: data.response.last_page,
//         total: data.response.total,
//       },
//     };
//   } catch (error) {
//     console.error("API Error:", error);
//     throw error;
//   }
// };

// export const verifyEmployer = async (id, verifyData) => {
//   const url = `${API_VERIFY_URL}/${id}`;
//   try {
//     const token = await fetchToken()

//     const response = await fetch(url, {
//       method: "POST",
//       headers: {
//         Accept: "application/json",
//         "Content-type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify(verifyData),
//     });
//     if (!response.ok) throw new Error(`Error updating: ${response.statusText}`);
//     const data = await response.json();
//     return {
//       ...data,
//       is_verified: true,
//     };
//   } catch (error) {
//     console.error("Verification error:", error);
//     throw error;
//   }
// };
import { fetchToken } from "../../common/FetchCookie"
import { ADMIN, BASE_URL, EMPLOYER_DATA, EMPLOYER_PROFILE_VERIFIED, FETCH_EMPLOYER_LIST } from "../../common/URLs"

const API_BASE_URL = `${BASE_URL}/${ADMIN}/${EMPLOYER_DATA}`
const API_EMPLOYER_LIST_URL = `${BASE_URL}/${ADMIN}/${FETCH_EMPLOYER_LIST}`
const API_VERIFY_URL = `${BASE_URL}/${ADMIN}/${EMPLOYER_PROFILE_VERIFIED}`

// Normalizes the admin list response into { candidates, pagination } (the shape
// the employer slice already consumes), tolerating the common Laravel paginator
// wrappers (`response` / `data` / bare array).
export const normalizeEmployerListResponse = (data) => {
  const paginator = data?.response ?? data?.data ?? data ?? {}
  const rows = Array.isArray(paginator) ? paginator : paginator?.data ?? []

  return {
    candidates: (Array.isArray(rows) ? rows : []).map((employer) => ({
      ...employer,
      is_verified: employer.is_verified === 1 || employer.is_verified === true,
    })),
    pagination: {
      current_page: paginator?.current_page ?? 1,
      last_page: paginator?.last_page ?? 1,
      total: paginator?.total ?? (Array.isArray(rows) ? rows.length : 0),
    },
  }
}

// GET admin/fetch-employer-list — admin-authenticated only. The Bearer token is
// read from the logged-in admin's cookie via fetchToken(); the route is also
// guarded by ProtectedRoute role="admin" on the client.
export const fetchEmployerList = async (page = 1) => {
  const url = `${API_EMPLOYER_LIST_URL}?page=${page}`
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)
    const data = await response.json()
    return normalizeEmployerListResponse(data)
  } catch (error) {
    console.error("API Error:", error)
    throw error
  }
}

export const fetchEmployerData = async (page = 1) => {
  const url = `${API_BASE_URL}?page=${page}`
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)
    const data = await response.json()
    return {
      candidates:
        data.response.data.map((candidate) => ({
          ...candidate,
          is_verified: candidate.is_verified === 1, // Convert to boolean
        })) || [],
      pagination: {
        current_page: data.response.current_page,
        last_page: data.response.last_page,
        total: data.response.total,
      },
    }
  } catch (error) {
    console.error("API Error:", error)
    throw error
  }
}

export const verifyEmployer = async (id, verifyData) => {
  const url = `${API_VERIFY_URL}/${id}`
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(verifyData),
    })
    if (!response.ok) throw new Error(`Error updating: ${response.statusText}`)
    const data = await response.json()
    return {
      ...data,
      is_verified: true,
    }
  } catch (error) {
    console.error("Verification error:", error)
    throw error
  }
}
